var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate0",
    attributeName: "r",
    begin: "0;svgSpinners12DotsScaleRotate2.end-0.375s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 4.21,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate1",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate0.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.21,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate2",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate4.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 7.5,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate3",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate1.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 7.5,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate4",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate6.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate5",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate3.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate6",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate8.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 16.5,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate7",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate5.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 16.5,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate8",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotatea.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 19.79,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotate9",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate7.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 19.79,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotatea",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotateb.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners12DotsScaleRotateb",
    attributeName: "r",
    begin: "svgSpinners12DotsScaleRotate9.begin+0.075s",
    calcMode: "spline",
    dur: "0.45s",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73",
    values: "1;2;1"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "4.5s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "360 12 12;0 12 12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a103844064710fecba688f6617d4c8f1.svg";
export { ForwardRef as ReactComponent };